/* eslint-disable max-classes-per-file */
import { SSR } from "../helpers/environment";
import type { HTTPResponse } from "./HTTPClient";
import { turnMaintenanceOn } from "../app/Maintenance";
import { localStorageWrapper } from "./LocalStorage";
import {
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_CLIENT,
  ACCESS_TOKEN_EXPIRY,
  ACCESS_TOKEN_UID,
  DOWNTIME_STATUS_CODE,
  SESSION_UNAUTHORIZED_ERROR_CODE,
} from "./constants";
import { getLocale } from "../helpers/locale";
import { HTTPClient } from "./HTTPClient";
import { isResponseUnauthorized } from "./utils";

export interface PaginationMeta {
  current: number;
  records?: number;
  next?: number;
  last?: number;
}
export class HTTPClientV3 extends HTTPClient {
  protected host = SSR
    ? process.env.NEXT_PUBLIC_API_URL_V3_SSR
    : process.env.NEXT_PUBLIC_API_URL_V3;

  private marketplaceNoAccounts: boolean | null = null;

  private requestHost: string | null = null;

  private requestUrl: string | null = null;

  constructor(
    requestHost: string | null,
    requestUrl: string | null,
    marketplaceNoAccounts: boolean | null,
  ) {
    super();
    this.requestHost = requestHost;
    this.requestUrl = requestUrl;
    this.marketplaceNoAccounts = marketplaceNoAccounts;
  }

  public getRequestHost() {
    return this.requestHost;
  }

  protected async request<T>(
    url: string,
    config: RequestInit,
  ): Promise<HTTPResponse<T>> {
    const headers = new Headers(config?.headers);
    if (!SSR) {
      const accessToken = localStorageWrapper.getItem(ACCESS_TOKEN_KEY);
      const client = localStorageWrapper.getItem(ACCESS_TOKEN_CLIENT);
      const expiry = localStorageWrapper.getItem(ACCESS_TOKEN_EXPIRY);
      const uid = localStorageWrapper.getItem(ACCESS_TOKEN_UID);
      if (accessToken) {
        headers.set(ACCESS_TOKEN_KEY, accessToken);
      }
      if (client) {
        headers.set(ACCESS_TOKEN_CLIENT, client);
      }
      if (expiry) {
        headers.set(ACCESS_TOKEN_EXPIRY, expiry);
      }
      if (uid) {
        headers.set(ACCESS_TOKEN_UID, uid);
      }
    }

    if (this.requestHost) {
      headers.set("origin", `https://${this.requestHost}`);
    }

    const path = this.requestUrl || "";
    const { locale } = getLocale(path);
    headers.set("Accept-Language", locale || "en");
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");
    config.headers = headers;

    const response = await fetch(this.getRequestUrl(url), config);

    if (isResponseUnauthorized(response) && !SSR) {
      if (this.marketplaceNoAccounts) {
        window.location.reload();
      } else {
        window.location.href = `/accounts/login?error=${SESSION_UNAUTHORIZED_ERROR_CODE}`;
      }
    }

    if (response.status === DOWNTIME_STATUS_CODE && !SSR) {
      turnMaintenanceOn();
    }

    return response;
  }
}
